<template>
  <div class="modal" v-if="loading">
    <template v-if="!done">
      <div class="deletefile">
        <span @click="closebox" class="closefile">
          <img src="@/assets/Close Button.svg" />
        </span>
        <!-- <div class="d-flex justify-content-center align-items-center mt-4">
          <img src="@/assets/trash-can.svg" />
        </div> -->
        <div class="header d-flex justify-content-center align-items-center mt-2">
          <h6><strong>File name conflict</strong></h6>
        </div>
        <div class="cgn text-center my-2">
          <span>File will be renamed to <strong>{{ new_name }}</strong></span>
        </div>
        <div class="save">
          <span class="btn-delete-permanently" @click="do_moveto">
            Continue
          </span>

          <span class="btn-move-to-trash" @click="move_replace">
            Copy and replace
          </span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="loading" v-if="done">
        <p class="note"><strong style="font-weight:bold;">{{ movedfile }}</strong> copied to <strong
            style="font-weight:bold;">{{ destination }}</strong></p>
        <p>
          <span class="btn cancel" @click="closebox">Cancel</span> &nbsp;&nbsp; <span class="btn ok" @click="goto">Go to
            location </span>
        </p>
      </div>
    </template>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      wait: true,
      loading: false,
      movedfileid: null,
      destination: '',
      destination_id: '',
      dir: [],
      folders: [],
      heading_dir: '',
      selected_folder_id: '',
      move_state: [],
      done: false,
      movedfile: '',
      load: false,
      new_name: '',
      index: ''
    }
  },
  methods: {
    ...mapMutations([
      'SET_FILE_ACTION',
      'REMOVE_FILE_ACTION',
      'SET_DIRECTORY_CHILDREN',
      'TOGGLE_FILE_INFO',
      'SORT_DIRECTORY_CHILDREN',
      'SORT_STORED_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'SET_FILE_INFO_DATA',
      'SET_CURRENT_FILE_ID',
      'SET_CURRENT_DIRECTORY',
      'SET_PATH',
      'HIDE_FILE_INFO',
      'SET_FILE_INDEX',
      'SET_FILES_INDEX',
      'SET_DIRECTORY_CHILDREN',
      'SET_CURRENT_DIRECTORY',
      'SET_PATH',
      'SORT_DIRECTORY_CHILDREN'
    ]),
    str_text(str) {
      if (str.length > 24) {
        let fSeg = str.substring(0, 5)
        let sSeg = str.substr(str.length - 12, 7)

        return fSeg + '....' + sSeg
      }
      return str
    },
    loaderclose() {
      this.$parent.closeloader()
    },
    loaderbrowse() {
      this.$parent.browseloader()
    },
    logincall() {
      this.$parent.logincall()
    },
    refreshfolder() {
      // this.$parent.loading(true);
      let data = {
        token: cookies.getCookie("token"),
        current_directory_id: localStorage.getItem("current_directory_id"),
        db: localStorage.getItem("db"),
        filepath: sessionStorage.getItem("filepath"),
      };

      let that = this;

      this.$socket.emit("refresh", data, function (data) {
        if (data.data === true) {
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
          // that.$parent.loading_close();
        }

        if (data.data === false) {
          // that.$parent.loading_close();
          //that.logincall();
          that.$router.push('/login')
        }
      });
    },
    loader(index, move_file_id, selected_folder_id, new_name) {
      this.loading = true
      this.wait = true
      this.movedfileid = move_file_id
      this.load = false
      this.selected_folder_id = selected_folder_id
      this.new_name = new_name
      this.move_state = []
      this.done = false
      this.index = index
    },
    move_replace() {
      if (this.selected_folder_id) {
        this.move_dist_folder = this.heading_dir

        let that = this

        let data = {
          move_file_id: this.movedfileid,
          selected_folder_id: this.selected_folder_id,
          token: cookies.getCookie('token')
        }

        this.load = true
        this.folders = []

        this.$socket.emit('move_and_replace', data, function (data) {
          if (data.data === false) {
            that.loading = false
            that.load = false
            that.seen = false
            that.logincall()
            that.$router.push('/login')
          }

          if (data.data === true && data.message === 'completed') {
            that.load = false
            that.done = true
            that.movedfile = data.movedfile
            that.destination = data.destination,
              that.destination_id = data.dir.id
            that.dir = data.dir
            that.refreshfolder()
            // that.$store.getters.DIRECTORY_CHILDREN.splice(that.index, 1)
          }
        })
      }
    },
    do_moveto() {
      if (this.selected_folder_id) {
        this.move_dist_folder = this.heading_dir

        let that = this

        let data = {
          move_file_id: this.movedfileid,
          selected_folder_id: this.selected_folder_id,
          token: cookies.getCookie('token'),
          ignore: true
        }

        this.load = true
        this.folders = []

        this.$socket.emit('move_file', data, function (data) {
          if (data.data === false) {
            that.loading = false
            that.load = false
            that.seen = false
            that.logincall()
            that.$router.push('/login')
          }

          if (data.data === true && data.message === 'completed') {
            that.load = false
            that.done = true
            that.movedfile = data.movedfile
            that.destination = data.destination,
              that.destination_id = data.dir.id
            that.dir = data.dir
            that.refreshfolder()
            // that.$store.getters.DIRECTORY_CHILDREN.splice(that.index, 1)
          }
        })
      }
    },
    goto() {
      if (this.destination_id) {
        this.loading = false
        this.wait = false

        let that = this

        let data = {
          db: this.dir.db,
          token: cookies.getCookie('token'),
          current_directory_id: this.destination_id
        }

        this.$socket.emit('browse', data, function (data) {
          if (data.message === 'completed') {
            localStorage.setItem('current_directory_id', that.dir.id)
            localStorage.setItem('current_directory', that.dir.name)
            localStorage.setItem('db', that.dir.db)
            that.SET_DIRECTORY_CHILDREN(data.directory_children)
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children)
            that.SET_CURRENT_DIRECTORY(that.dir.name)
            that.SET_PATH(data.dir_path)
            that.SORT_DIRECTORY_CHILDREN()
            that.seen = false
          }

          if (data.data == false) {
            that.loading = false
            that.wait = false
            that.seen = false
            that.logincall()
            that.$router.push('/login')
          }
        })
      }
    },
    close() {
      this.loading = false
      this.wait = false
    }
  }
}
</script>
